/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import CardPlacement from 'material/embeds/cardplacement/cardplacement';
import { Page, Content, InlineMessage, Tip } from '@insticator/insticator-ui'; // iui-material
import FlowControls from 'material/embeds/flowcontrols/flowcontrols_container'
import EmbedControls from 'material/embeds/embedcontrols/embedcontrols_container';
import NewContentCTA from 'material/ctas/newcontent/newcontent_container';
import EmbedProperties from 'pages/dashboard/embeds/management/customize/embedproperties/embedproperties_container';
import CardProperties from 'pages/dashboard/embeds/management/customize/cardproperties/cardproperties_container';
import EmbedEditor from 'pages/dashboard/embeds/management/customize/embededitor/embededitor_container';
import ContentSelector from 'pages/dashboard/embeds/management/customize/contentselector/contentselector_container';
import PropertyCard from 'material/embeds/propertycard/propertycard';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/customize/customize_styles';



/* ========== ~~~~~~~~~~ EMBED CUSTOMIZE ~~~~~~~~~~ ========== */
class CustomizePage extends Component {
    constructor(props){
        super(props);

        this.state = {
            cardPlacement: 1
        }

    }
    isStep() {
        return this.props.currentStepPage !== null || this.props.currentStepPage !== undefined ? 'step' : 'standard';
    }
    showPlacement() {
        return this.props.location === 'in-content' ? 'incontent' : 'rail';
    }

    numberOfLiveContents = () => Object.keys(this.props.content).filter(content => this.props.content[content].contentLive).length;

    /* /////////////// RENDER \\\\\\\\\\\\\\\ */
    render() {
        return (
            <Page name={`customize`} klass={`${this.props.classes.customize} ${this.isStep()} ${this.showPlacement()}`}>
                <Content>
                    <div className={'imageprocessing'}>
                      <InlineMessage 
                        name={'imageprocessingmessage'} 
                        variant={'primary'} 
                        icon={'exclamation-triangle'} 
                        message={
                          <div>
                            The images you select go through a size reduction process so that they load quickly to the end-user viewing the embed. 
                            This process takes time. We'll send you an email when all the images finish processing. 
                            Preview function may not work properly until images have finished processing. 
                            <Tip 
                              space={'left'} 
                              icon={'question-circle'} 
                              content={`
                                Once you receive that email, this embed is safe to set live on a website. 
                                If you set the embed live before receiving this email, there is a chance that some images will not show.
                              `} 
                            />
                          </div>
                        }
                      />
                    </div>
                    <EmbedControls handleSaveEmbed={this.props.handleSaveEmbed} />
                    <div className={`grouper`}>
                        <div className={`group`}>
                            <CardProperties />
                        </div>
                        <div className={`group`}>
                            <EmbedEditor />
                            <CardPlacement
                                value={this.state.cardPlacement}
                                handleChange={placement => this.setState({cardPlacement: placement})}
                                numberOfContents={this.numberOfLiveContents()}
                                />
                            <NewContentCTA placement={this.state.cardPlacement} disabled={this.state.cardPlacement < 1} />
                        </div>
                        <div className={`group`}>
                            <PropertyCard title={'Embed Branding'} properties={<EmbedProperties />}/>
                        </div>
                    </div>
                </Content>
                <div className={'controls'}>
                    <FlowControls handleSaveEmbed={this.props.handleSaveEmbed} />
                    {this.props.numberOfContents > 0 && <ContentSelector cardPlacement={this.state.cardPlacement} />}
                </div>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CustomizePage);
